<template>
  <a-table class="table" :columns="columns" :dataSource="tableData" :pagination="false" bordered> </a-table>
</template>
<script>
import { getAssetDepreciationParameters } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('接口', model)
        this.initTableData(model)
      },
      immediate: true
    },
  },
  data () {
    return {
      columns: [
        {
          title: '范围编号',
          dataIndex: 'afabe',
          align: 'center',
          width: 100
        },
        {
          title: '折旧范围',
          dataIndex: 'zjfw',
          align: 'center',
          width: 100
        },
        {
          title: '折旧码',
          dataIndex: 'afasl',
          align: 'center',
          width: 100
        },
        {
          title: '使用年限',
          dataIndex: 'ndjar',
          align: 'center',
          width: 100
        },
        {
          title: '期间',
          dataIndex: 'ndper',
          align: 'center',
          width: 100
        },
        {
          title: '普通折旧开始日期',
          dataIndex: 'afabg',
          align: 'center',
          width: 100
        }
      ],
      tableData: []
    }
  },
  methods: {
    // 获取表格数据
    initTableData (model) {
      const params = {
        anln1: model.anln1,
        bukrs: model.bukrs,
        anln2: model.anln2
      }
      getAssetDepreciationParameters(params).then((res) => {
        // console.log('数据', res.data)
        if (res.status === 0) {
          this.tableData = res.data
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
</style>
